import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { AccessDashboardGuard } from '../core/guards/access-dashboard-guard.service';
import { DefaultPageGuard } from '../core/guards/default-page-guard.service';
import { DashboardComponent } from './dashboard.component';

const routes: Route[] = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [DefaultPageGuard, AccessDashboardGuard],
  },
  {
    path: 'dashboard/overview',
    component: DashboardComponent,
    canActivate: [DefaultPageGuard, AccessDashboardGuard],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
